import dayjs from 'dayjs';
import _duration from 'dayjs/plugin/duration';

dayjs.extend(_duration);

export function getDuration(ms = 0) {
    const duration = dayjs.duration(ms);
    return duration.format('HH:mm:ss.SSS');
}

export function getDurationSec(ms = 0) {
    return dayjs.duration(ms).asSeconds();
}

export const formatTimeoutDuration = (duration: ReturnType<typeof dayjs.duration>): string => {
    const minutes = Math.floor(duration.asMinutes());
    const seconds = duration.asSeconds() % 60 || 0;

    if (minutes > 0) {
        return `${minutes} min ${Math.floor(seconds)} sec`;
    }
    return `${Math.floor(seconds)} sec`;
};
